import { getCookie, setCookie } from '../cookie';

export function checkFirstImp() {
  const firstimp = getCookie('camp_first_impression');

  if (!firstimp) {
    // making the cookie a session cookie to match inc's first imp implementation:
    setCookie('camp_first_impression', 'true');
    return true;
  }
  return false;
}
